import { useMemo, useSyncExternalStore } from "react";
import { getChatSubscriptionStore } from "../stores/chatSubscriptionStore.js";
/**
 * Returns the state of the ChatSubscriptionStore for the given styleId:
 * - `initialized` flips to true once the "initial" event has populated the
 *   store (via `setInitialChats`) and back to false on `clear()`.
 * - `connectionState` mirrors the tRPC `subscribeToStyle` subscription state
 *   ("connecting" | "pending" | "idle" | "error").
 */
export function useChatStoreState(styleId) {
    const store = getChatSubscriptionStore(styleId);
    const initialized = useSyncExternalStore(store.subscribeInitialized, store.getInitializedSnapshot);
    const connectionState = useSyncExternalStore(store.subscribeConnectionState, store.getConnectionStateSnapshot);
    return useMemo(() => ({
        initialized,
        connectionState,
    }), [initialized, connectionState]);
}
